import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

import type { IBaseComponentProps } from 'infrastructure/interfaces';

interface IProps extends IBaseComponentProps {
  opened: boolean;
  initialHeight?: number;
  duration?: number;
  disableAnimation?: boolean;
  className?: string;
}

const CollapseAnimation: React.FC<IProps> = (props) => {
  const {
    opened,
    initialHeight = 0,
    duration = 0.3,
    children,
    uniqueKey,
    disableAnimation,
    className,
  } = props;

  const ref = useRef<HTMLDivElement>(null);

  const [height, setHeight] = useState<number>(initialHeight);

  const animate = disableAnimation
    ? { height: 'auto' }
    : {
        height: opened ? 'auto' : `${height}px`,
      };

  useEffect(() => {
    setTimeout(() => {
      if (Boolean(initialHeight) && ref.current) {
        setHeight(ref.current.clientHeight);
      }
    }, 50);
  }, [ref, uniqueKey]);

  return (
    <motion.div
      initial={{ height: `${height}px` }}
      animate={animate}
      exit={{ height: `${height}px` }}
      transition={{ duration }}
      style={{ overflow: 'hidden' }}
    >
      <div ref={ref} className={className}>
        {children}
      </div>
    </motion.div>
  );
};

export default CollapseAnimation;
